import React from "react";
// import { motion } from "framer-motion";
// import { animationVariants } from '../../content/animationVariants';
import {
  InfoContainer,
  InfoWrapper,
  InfoRow,
  ColumnOne,
  TextWrapper,
  TopLine,
  Heading,
  Subtitle,
  BtnWrap,
  ColumnTwo,
  ImgWrap,
  Img,
  ButtonInfo,
} from "./InfoElements";
import { useTranslation } from "react-i18next";
import { animationVariants } from "../../constants/animationVariants";

const InfoSection = ({
  id,
  lightBg,
  imgStart,
  topLine,
  lightText,
  headline,
  darkText,
  description,
  start,
  buttonLabel,
  img,
  alt,
  lightTextTop,
  linked,
  target,
  primary,
  dark,
  dark2,
  imgBig,
}) => {
  const { t } = useTranslation();

  return (
    <InfoContainer
      lightBg={lightBg}
      id={id}
      initial="initial"
      whileInView="animate"
      viewport={{ once: true, amount: 0.2 }}
      transition={{ staggerChildren: 0.2 }}
    >
      <InfoWrapper>
        <InfoRow imgStart={imgStart}>
          <ColumnOne variants={animationVariants.fadeLeft}>
            <TextWrapper>
              <TopLine lightTextTop={lightTextTop}>{t(topLine)}</TopLine>
              <Heading lightText={lightText}>{t(headline)}</Heading>
              <Subtitle darkText={darkText}>{t(description)}</Subtitle>
              <BtnWrap>
                <div>
                  <ButtonInfo
                    to={`${linked}`}
                    target={target}
                    smooth={true}
                    duration={500}
                    spy={true}
                    exact="true"
                    offset={-80}
                  >
                    {t(buttonLabel)}
                  </ButtonInfo>
                </div>
              </BtnWrap>
            </TextWrapper>
          </ColumnOne>
          <ColumnTwo variants={animationVariants.fadeRight}>
            <ImgWrap start={start}>
              <Img src={img} alt={alt} imgBig={imgBig} />
            </ImgWrap>
          </ColumnTwo>
        </InfoRow>
      </InfoWrapper>
    </InfoContainer>
  );
};

export default InfoSection;
